import Vue from 'vue';
import Router from 'vue-router';
import home from '../components/home';
import hard from '../components/hardProduct/hard';
import hardone from '../components/hardProduct/hardone';
import hardtwo from '../components/hardProduct/hardtwo';
import software from '../components/software/software.vue';
import Isoftware from '../components/software/Isoftware.vue';
import cooperation from '../components/coopera/cooperation.vue';
import about from '../components/aboutUs/about.vue'
import log from '../components/login/log'
import aboutus from '../components/aboutUs/aboutus'
import history from '../components/aboutUs/history'
import join from '../components/aboutUs/join'
import bcoopera from '../components/aboutUs/BCoopera'
import agree from '../components/login/agree'

Vue.use(Router);

export default new Router({
	//  mode : 'history',
	routes: [
		 {
		 	path: '/',
			 redirect: '/home',
			//  component: home
		},
		 {
		 	path: '/home',
		 	name: 'home',
		 	component: home
		},
		{
			path:'/hard',
			name:'hard',
			component:hard
		},
		{
			path:'/hard/hardone',
			name:'hardone',
			component:hardone
		},
		{
			path:'/hard/hardtwo',
			name:'hardtwo',
			component:hardtwo
		},
		{
			path:'/software',
			name:'software',
			component:software
		},
		{
			path:'/Isoftware',
			name:'Isoftware',
			component:Isoftware
		},
		{
			path:'/cooperation',
			name:'cooperation',
			component:cooperation
		},
		{
		 	path:'/log',
		 	name:'log',
		 	component:log
		 },
		{
			path:'/about',
			name:'about',
			component:about,
			//  children:[
			//  	{
			//  		path:'/',
			//  		name:'aboutus',
			//  		component:aboutus
			//  	},
				 
			//  ]
		},
		{
			path:'/about/history',
			name:'history',
			component:history
		},
		{
			path:'/about/join',
			name:'join',
			component:join
		},
		{
			path:'/about/bcoopera',
			name:'bcoopera',
			component:bcoopera
		},
		{
			path:'/agree',
			name:'agree',
			component:agree
		}
	]
});



// WEBPACK FOOTER //
// ./src/router/index.js